import urlUtils from "@/common/utils/urlUtils";

export function spinner(): string {
  const ret =
    '\
  <div style="width:100%;height:100%;">\
  	<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 width="50.332px" height="50px" viewBox="373.834 373.996 50.332 50"	 xml:space="preserve" id="pixmoto-spinner" style="display:inline-block;position:absolute;top: 50%;left: 50%;-webkit-transform:translateX(-50%) translateY(-50%);-ms-transform:translateX(-50%) translateY(-50%);transform: translateX(-50%) translateY(-50%);width:50px;height:50px;"><defs><style type="text/css"><![CDATA[@keyframes pixmoto-spinner{50%{opacity:0}100%{opacity:1}}]]></style></defs><circle style="animation:pixmoto-spinner 2s ease alternate infinite;animation-delay:.1s;" fill="#F04943" cx="392.104" cy="419.505" r="4.491"/><circle style="animation:pixmoto-spinner 2s ease alternate infinite;animation-delay:.2s;" fill="#F04943" cx="391.848" cy="405.829" r="4.49"/><circle style="animation:pixmoto-spinner 2s ease alternate infinite;animation-delay:.3s;" fill="#F04943" cx="406.151" cy="405.829" r="4.49"/><circle style="animation:pixmoto-spinner 2s ease alternate infinite;animation-delay:.4s;" fill="#F04943" cx="391.909" cy="392.164" r="4.491"/><circle style="animation:pixmoto-spinner 2s ease alternate infinite;animation-delay:.5s;" fill="#F04943" cx="406.214" cy="392.164" r="4.491"/><circle style="animation:pixmoto-spinner 2s ease alternate infinite;animation-delay:.6s;" fill="#B4B4B4" cx="378.386" cy="419.505" r="4.491"/><circle style="animation:pixmoto-spinner 2s ease alternate infinite;animation-delay:.7s;" fill="#B4B4B4" cx="405.822" cy="419.505" r="4.491"/><circle style="animation:pixmoto-spinner 2s ease alternate infinite;animation-delay:.8s;" fill="#B4B4B4" cx="419.542" cy="419.31" r="4.49"/><circle style="animation:pixmoto-spinner 2s ease alternate infinite;animation-delay:.9s;" fill="#B4B4B4" cx="378.325" cy="405.829" r="4.49"/><circle style="animation:pixmoto-spinner 2s ease alternate infinite;animation-delay: 1.0s;" fill="#B4B4B4" cx="419.674" cy="405.829" r="4.49"/><circle style="animation:pixmoto-spinner 2s ease alternate infinite;animation-delay: 1.1s;" fill="#B4B4B4" cx="378.386" cy="392.164" r="4.491"/><circle style="animation:pixmoto-spinner 2s ease alternate infinite;animation-delay: 1.2s;" fill="#B4B4B4" cx="419.542" cy="392.164" r="4.491"/><circle style="animation:pixmoto-spinner 2s ease alternate infinite;animation-delay: 1.3s;" fill="#B4B4B4" cx="378.386" cy="378.487" r="4.491"/><circle style="animation:pixmoto-spinner 2s ease alternate infinite;animation-delay: 1.4s;" fill="#B4B4B4" cx="392.104" cy="378.487" r="4.491"/><circle style="animation:pixmoto-spinner 2s ease alternate infinite;animation-delay: 1.5s;" fill="#B4B4B4" cx="406.214" cy="378.487" r="4.491"/><circle style="animation:pixmoto-spinner 2s ease alternate infinite;animation-delay: 1.6s;" fill="#B4B4B4" cx="419.542" cy="378.487" r="4.491"/></svg>\
  </div>';

  return ret;
}

export function getElements(obj: unknown): Element[] {
  const ret: Element[] = [];
  if (typeof obj === "string" || obj instanceof String) {
    const nl = document.querySelectorAll(obj as string);
    for (let n = 0, max = nl.length; n < max; n++) {
      ret.push(nl[n]);
    }
  } else if (
    typeof HTMLElement === "object"
      ? obj instanceof HTMLElement //DOM2
      : obj &&
        typeof obj === "object" &&
        obj !== null &&
        (obj as Node).nodeType === 1 &&
        typeof (obj as Node).nodeName === "string"
  ) {
    ret.push(obj as Element);
  }
  return ret;
}

export function getWindowSize() {
  return {
    width:
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth,
    height:
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight,
  };
}

export function getUrlParameter(name: string): string | undefined {
  return urlUtils.querySettings()[name];
}
